import ProceduresTable from './ProceduresTable';

export default ProceduresTable;
